import React, { useEffect, useState, useRef } from 'react';

import {EDIT_ORDER,GET_COMPLETE_COUNT} from '@/services/wish';

import imgBg from '@/assets/images/wishDetail/bg.png';
import imgTitle from '@/assets/images/wishDetail/title.png';
import imgIcon from '@/assets/images/wishDetail/icon.png';
import imgLabelAdd from '@/assets/images/wishDetail/labelAdd.png';
import imgLabelOrder from '@/assets/images/wishDetail/labelOrder.png';
import imgStep1Title from '@/assets/images/wishDetail/step1Title.png';
import imgStep2Title from '@/assets/images/wishDetail/step2Title.png';
import imgStep3Title from '@/assets/images/wishDetail/step3Title.png';
import imgClose from '@/assets/images/complete/close.png';

import Paper from '@/pages/components/dialog/paper';
import Input from '@/pages/components/input';
import Select from '@/pages/components/select';

import {SEND_DATE} from '@/utils';
import styles from './index.less';
import ShowComplete from '@/pages/components/dialog/complete';
import { useParams } from 'react-router-dom';


const WishDetail = (props) => {
  const [edit,setEdit] = useState(true);
  const searchParams= useParams();
  const [companyError,setCompanyError]= useState('');
  const [numberError,setNumberError]= useState('');
  const [wishOwnerError,setWishOwnerError]= useState('');
  const companyList = [[
    { label: '恺英伙伴', key: '恺英伙伴',value:'恺英伙伴' },
    { label: '盛和伙伴', key: '盛和伙伴' ,value:'盛和伙伴'},
    { label: '社会爱心人士', key: '社会爱心人士' ,value:'社会爱心人士'},
  ]]
  
  const [wish,setWish] = useState(()=>{
    let item = sessionStorage.getItem('wish');
    item= JSON.parse(item);
    item.sender = item.sender||'';
    item.corporation = item.corporation||'';

    if(item.express_number&&item.express_company){
      setEdit(false);
    }
    console.log(item)
    return item;
  })

  const onEdit=()=>{
    setEdit(true);
  }
  const onChange=(type,value)=>{
    wish[type] = value;
    switch(type){
      case 'express_company':{
        setCompanyError('');
      }break;
      case 'express_number':{
        setNumberError('');
      }break;
      case 'sender':{
        setWishOwnerError('');
      }
    }
    setWish({...wish});
  }
  const onOk= async ()=>{

    console.log('wish',wish)
    const {express_company='',express_number='',id='',sender=''} = wish;
    let {corporation=''} = wish;

    let error=false;
    if(!/\S+/.test(express_number)||!express_number){
      setNumberError('请输入运单号');
      error=true;
    }
    if(!/\S+/.test(express_company)||!express_company){
      setCompanyError('请输入快递公司');
      error=true;
    }
    if(!/\S+/.test(sender)||!sender){
      setWishOwnerError('请输入心愿领取人名字');
      error=true;
    }
    if(error)return;
    if(Array.isArray(corporation)){
      corporation=corporation[0];
    }
    const req = await EDIT_ORDER(id,{
      express_number,
      express_company,
      corporation,
      sender

    });
    if(req?.code==0){
      setEdit(false);
      const reqCount = await GET_COMPLETE_COUNT();
      if(reqCount?.code==0){
        ShowComplete({count:reqCount.data});
        props.destory(false);
      }
    }

  }
  // const onClose=()=>{
  //   props.destory(false)
  // }
  if(!wish)return <></>
  return (
    <section className={styles.wrap}>
      <img src={imgBg} className={styles.bg} />
      <img src={imgTitle} className={styles.title}  />
      <div className={styles.status} disabled={wish?.wish?.state=='Completed'} >{wish?.wish?.state=='Completed'?'已寄出':'待邮寄'}</div>

      <img src={imgStep1Title} className={styles.step1Title}  />
      <section className={`${styles.contentWrap} ${styles.wrapWishPaper}`}>
        <Paper id={searchParams.id} wish={wish.wish} showBack={true} />
      </section>
      
      <img src={imgStep2Title} className={styles.step2Title}  />
      <section className={`${styles.contentWrap} ${styles.address}`} data-type='normal'>
        <img src={imgLabelAdd} className={styles.editLabel} />
        <span className={styles.tip}>请于{SEND_DATE}，自行寄送心愿礼物</span>
        <div className={styles.line} ></div>
        <hgroup className={styles.info}>
          <span>收件人</span>
          <span>{wish?.wish?.name||'-'}</span>
        </hgroup>
        <hgroup className={styles.info}>
          <span>联系电话</span>
          <span>{wish?.wish?.mobile||'-'}</span>
        </hgroup>
        <hgroup className={styles.info}>
          <span>收件地址</span>
          <span>{wish?.wish?.address||'-'}{wish?.wish?.school} {wish?.wish?.class}</span>
        </hgroup>

      </section>

      <img src={imgStep3Title} className={styles.step3Title}  />
      <section className={`${styles.contentWrap} ${styles.order}`} data-type='normal'>
        <div className={styles.row1}>
          <hgroup className={styles.left}>
            <span className={styles.tips}>为跟进快递，让您的礼物成功接收物品寄出后，请填写</span>
            <hgroup className={styles.row2}>
              <img src={imgLabelOrder} className={styles.editLabel} />
              {!edit&&<span className={styles.edit} onClick={onEdit}>再次编辑</span>}
            </hgroup>
          </hgroup>
          <img className={styles.right} src={imgIcon} />
        </div>
        <Input label='快递公司' readOnly={!edit} error={companyError} value={wish?.express_company||''} onChange={onChange.bind(this,'express_company')} />
        <Input label='快递单号' readOnly={!edit} error={numberError} value={wish?.express_number||''} onChange={onChange.bind(this,'express_number')} />
        <Input label='心愿领取人' readOnly={!edit} error={wishOwnerError} value={wish?.sender||''} onChange={onChange.bind(this,'sender')} />
        <Select label='爱心单位' list={companyList} readOnly={!edit} value={wish?.corporation||''} onChange={onChange.bind(this,'corporation')} />

        {
          edit&&(
            <section className={styles.btnWrap}>
              <div className={styles.btn} onClick={onOk}>提交</div>
            </section>
          )
        }
        
      </section>

{/* 
      <div onClick={onClose} className={styles.close}>
        <img src={imgClose} />
      </div> */}

    </section>

  )
}

export default WishDetail;